import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Cleave from 'cleave.js/react';
import { capitalize } from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';
import { Error } from '../../Error';
import { getContainerClasses } from '../BaseInput/BaseInput';
import { InputSizes, ValidationStates } from '../enums';
import { Icon } from '../../Icon';
import styles from '../BaseInput/BaseInput.scss';
export function createDateInput(sizeType) {
  var _a;

  return _a = /*#__PURE__*/function (_React$Component) {
    _inherits(DateInputBase, _React$Component);

    var _super = _createSuper(DateInputBase);

    function DateInputBase() {
      var _this;

      _classCallCheck(this, DateInputBase);

      _this = _super.apply(this, arguments);
      _this.state = {
        validationState: ValidationStates.None,
        errorMessage: null
      };

      _this.handleOnBlur = function (event) {
        var validDateState = {
          validationState: ValidationStates.Success,
          errorMessage: ''
        };
        var invalidDateState = {
          validationState: ValidationStates.Error,
          errorMessage: 'The date specified is invalid. Enter a date as MM / DD / YYYY.'
        };
        var requiredDateState = {
          validationState: ValidationStates.Error,
          errorMessage: 'A date is required. Enter a date as MM / DD / YYYY.'
        };
        var value = event.target.value;
        var date = DateTime.fromFormat(value.split(' / ').join('/'), 'mm/dd/yyyy');
        var state = null;

        if (!value && _this.props.required) {
          state = requiredDateState;

          _this.props.onDateValid(false, value, false);
        } else if (date.isValid) {
          state = validDateState;

          _this.props.onDateValid(true, value, true);
        } else {
          state = invalidDateState;

          _this.props.onDateValid(false, value, false);
        }

        _this.setState(state);
      };

      _this.handleOnChange = function (event) {
        var value = event.target.value;

        _this.props.onChange(value.split(' / ').join('/'));
      };

      return _this;
    }

    _createClass(DateInputBase, [{
      key: "render",
      value: function render() {
        var inputSize = capitalize(this.props.size) || sizeType;
        var validationState = this.props.validationState || this.state.validationState;
        var containerClasses = getContainerClasses(inputSize, validationState, this.props.disabled);
        return React.createElement(React.Fragment, null, React.createElement("div", {
          className: containerClasses
        }, React.createElement(Cleave, Object.assign({
          id: this.props.id,
          className: styles.input,
          disabled: this.props.disabled,
          options: {
            date: true,
            datePattern: ['m', 'd', 'Y'],
            delimiter: ' / '
          },
          value: this.props.value,
          placeholder: "MM / DD / YYYY",
          onBlur: this.handleOnBlur,
          onChange: this.handleOnChange
        }, this.props.dataTest && {
          'data-test': this.props.dataTest
        })), validationState && React.createElement("span", {
          className: styles.iconWrapper
        }, validationState === ValidationStates.Success && React.createElement(Icon, {
          className: styles.icon,
          icon: "status-success"
        }), validationState === ValidationStates.Error && React.createElement(Icon, {
          className: styles.icon,
          icon: "status-error"
        }))), this.state.errorMessage && React.createElement(Error, null, this.state.errorMessage));
      }
    }]);

    return DateInputBase;
  }(React.Component), _a.defaultProps = {
    onChange: function onChange() {},
    onDateValid: function onDateValid() {}
  }, _a.displayName = "Input.Date.".concat(sizeType), _a;
}

function generateDateInputWithSizes() {
  var DefaultDateInput = createDateInput(InputSizes.Default);
  return Object.assign.apply(Object, [DefaultDateInput].concat(_toConsumableArray(Object.keys(InputSizes).map(function (sizeType) {
    return _defineProperty({}, sizeType, createDateInput(InputSizes[sizeType]));
  }))));
}

export var DateInput = generateDateInputWithSizes();